import { Sparkles } from "lucide-react";

const ITEMS = [
  "Undangan Pernikahan",
  "Website UMKM",
  "Profil Influencer",
  "Portal Masjid Gratis",
  "Web Kejutan Hadiah",
  "Setiap Momen Layak Dirayakan",
];

export default function Marquee() {
  return (
    <section
      aria-hidden
      data-testid="marquee-strip"
      className="overflow-hidden border-y border-[#C9A227]/15 bg-[#0B132B] py-10"
    >
      <div className="marquee-track">
        {[0, 1].map((dup) => (
          <div key={dup} className="flex shrink-0 items-center">
            {ITEMS.map((text) => (
              <span key={`${dup}-${text}`} className="flex items-center">
                <span className="font-display whitespace-nowrap px-8 text-3xl italic text-[#F6F0E6]/90 md:text-5xl">
                  {text}
                </span>
                <Sparkles size={18} className="shrink-0 text-[#C9A227]" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}
